import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import AppointmentsPage from 'model/ApointmentsPage'

export class AppointmentsPagesRepository extends WebRepository<AppointmentsPage> {
  constructor() {
    super(new Api('appointments'))
  }

  async searchPatientAppointmentsPage(
    selector: any,
    bookmark: string,
    limit?: number,
  ): Promise<AppointmentsPage> {
    return super.searchPage({
      selector,
      sort: {
        startDateTime: -1,
      },

      limit: limit || 10,
      bookmark: bookmark,
    })
  }

  async searchPatientAppointmentsPageText(
    selector: any,
    bookmark: string,
    text: string,
    limit?: number,
  ): Promise<AppointmentsPage> {
    return super.searchPage({
      selector: {
        $and: [
          {
            patientId: selector.patientId,
          },
          {
            type: selector.type,
          },
          {
            $or: [
              {
                location: {
                  $regex: '(?i)' + text,
                },
              },
              {
                reason: {
                  $regex: '(?i)' + text,
                },
              },
              {
                type: {
                  $regex: '(?i)' + text,
                },
              },
            ],
          },
        ],
      },
      sort: {
        startDateTime: -1,
      },

      limit: limit || 10,
      bookmark: bookmark,
    })
  }
}

export default new AppointmentsPagesRepository()
